import React from 'react';
import {
    VerificationService,
    ViewModel,
} from '@sheerid/jslib';
import { OptInComponent } from '../OptIn/OptInComponent'

interface TermsAndConditionsProps {
  verificationService: VerificationService;
  isErrored: boolean;
  onChange: (value: any) => void;
  viewModel: ViewModel;
}

const TermsAndConditionsComponent = ({
    verificationService,
    isErrored,
    onChange,
    viewModel,
}: TermsAndConditionsProps) => (
    <OptInComponent
        isErrored={isErrored}
        isRequired
        verificationService={verificationService}
        value={(viewModel.metadata && viewModel.metadata.termsAndConditions) || false}
        onChange={(value: boolean) => onChange(value)}
    />
);

export { TermsAndConditionsComponent };
